import UtilsType from "./UtilsType"
import {ResponseError} from "../models"
import {Role} from "../modules/auth/constants"

const Utils: UtilsType = Object.create(null);

/**
 * Encode a string to base64
 * @param string
 */
Utils.base64Encode = function base64Encode(string: string): string {
    return window.btoa(string)
};

/**
 * Formik email validation callback
 *
 * @param {string} email
 * @returns {string}
 */
Utils.validateEmail = function validateEmail(email: string): string | undefined {
    if (!email) {
        return "validation.required"
    } else if (false === /^\w+([.-/+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return "validation.invalid_email"
    }
};

/**
 * Formik password validation callback
 *
 * @param {string} password
 * @returns {string}
 */
Utils.validatePassword = function validatePassword(password: string): string | undefined {
    if (!password) {
        return "validation.required"
    } else if (password.length < 8) {
        return "validation.short_password"
    } else if (password.length > 25) {
        return "validation.long_password"
    } else if (password.trim() !== password) {
        return "validation.invalid_password"
    }
};

/**
 * Extract error message string from Ajax response object
 *
 * @param errorResponse
 */
Utils.extractResponseErrorMessage = function extractResponseErrorMessage(errorResponse) {
    const {status, response} = errorResponse;
    const responseError: ResponseError = {status};

    if (response === null) {
        responseError.message = "error_message.something_went_wrong";

        return responseError
    }

    const {message, error} = response;

    if ((status === 400 || status === 401) && typeof error !== "undefined") {
        responseError.message = `error_message.${error}`;

        return responseError
    }

    responseError.message = message;

    return responseError
};

/**
 * Proper display of aVR, aVL, aVF lead names
 *
 * @param {string} name
 * @returns {string}
 */
Utils.normalizeLeadName = function normalizeLeadName(name) {
    if (/a/i.test(name)) {
        return name.slice(0, 1).toLowerCase().concat(name.slice(1))
    }

    return name
};

/**
 * Limit signal size to 15 seconds
 *
 * @param sampleRate
 * @param data
 */
Utils.normalizeLeadDataSize = function normalizeLeadDataSize(sampleRate, data) {
    const expectedDataLength = 15 * sampleRate;

    if (data.length <= expectedDataLength) {
        return data
    }

    return data.slice(0, expectedDataLength)
};

/**
 * @param user
 */
Utils.isCompanyMaster = function isCompanyMaster(user) {
    return user !== null && user.role === Role.COMPANY_MASTER
};

export default Utils
